(() => {
  // listen to when quick buy is open -> trigger window.Abra.render()
  document.addEventListener("DOMContentLoaded", function () {
    let lastOpenedId = null;
    
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const modal = node.classList?.contains('quickbuy-form') ? node : node.querySelector?.('.quickbuy-form');
            
            if (modal) {
              const currentId = modal.dataset?.productId;
              
              if (currentId && currentId !== lastOpenedId) {
                console.log('Quick buy opened for product:', currentId);
                window.dispatchEvent(new CustomEvent('quickbuy:opened'));
                lastOpenedId = currentId;
                
                setTimeout(() => window.Abra.render(), 100);
                setTimeout(() => window.Abra.render(), 300);
                setTimeout(() => window.Abra.render(), 500);
                
                setTimeout(() => setupVariantListener(modal), 100);
              }
            }
          }
        });
        
        if (mutation.type === 'attributes' && (mutation.attributeName === 'style' || mutation.attributeName === 'class')) {
          const modal = document.querySelector('.quickbuy-form');
          const isVisible = modal && (modal.offsetParent !== null || modal.style.display !== 'none');
          const currentId = modal?.dataset?.productId;
          
          if (isVisible && currentId && currentId !== lastOpenedId) {
            console.log('Quick buy visibility changed for product:', currentId);
            lastOpenedId = currentId;
            
            setTimeout(() => window.Abra.render(), 100);
            setTimeout(() => window.Abra.render(), 300);
            setTimeout(() => setupVariantListener(modal), 100);
          }
        }
      });
    });
    
    observer.observe(document.body, { 
      childList: true, 
      subtree: true, 
      attributes: true, 
      attributeFilter: ['style', 'class'] 
    });
  });
  
  function setupVariantListener(quickbuyForm) {
    const variantSelect = quickbuyForm.querySelector('select[data-product-select]');
    
    if (variantSelect) {
      variantSelect.removeEventListener('change', handleVariantChange);
      
      variantSelect.addEventListener('change', handleVariantChange);
      
      console.log('Variant selector listener setup');
    }
  }
  
  function handleVariantChange(event) {
    const selectedVariantId = event.target.value;
    const quickbuyForm = event.target.closest('.quickbuy-form');
    
    if (quickbuyForm && selectedVariantId) {
      quickbuyForm.setAttribute('data-variant-id', selectedVariantId);
      
      console.log('Variant changed to:', selectedVariantId);
      
      setTimeout(() => {
        window.Abra.render();
      }, 200);
    }
  }
})();